module.exports = __webpack_public_path__ + "static/media/Carousel-1.a0d66a48.svg";